import { IntegrationsApiKeysRoutes } from './api-keys-routes';
import { AttendanceNoteTemplateRoutes } from './attendance-note-template-routes';
import { AttendanceRoutes } from './attendance-routes';
import { AuthenticationRoutes } from './authentication-routes';
import { BillingProfilesRoutes } from './billing-profiles-routes';
import { CalendarRoutes } from './calendar-routes';
import { CashCategoryRoutes } from './cash-category-routes';
import { CashRoutes } from './cash-routes';
import { CountryRoutes } from './country-routes';
import { CurrencyRoutes } from './currency-routes';
import { EmailMediaLibraryRoutes } from './email-media-library-routes';
import { EmailAddressVerificationRoutes } from './email-address-verification-routes';
import { EventCategoryRoutes } from './event-categories-routes';
import { EventLocationRoutes } from './event-location-routes';
import { FamilyRoutes } from './families-routes';
import { HealthCheckRoutes } from './health-check-routes';
import { AssetsRoutes } from './assets-routes';
import { InvoicesRoutes } from './invoices-routes';
import { LendingLibraryRoutes } from './lending-library-routes';
import { LocalizationRoutes } from './localization-routes';
import { MapLocationRoutes } from './map-location-routes';
import { MembershipRoutes } from './membership-routes';
import { MessageTemplateRoutes } from './message-template-routes';
import { MessagingRoutes } from './messaging-routes';
import { MileageRoutes } from './mileage-routes';
import { NewsRoutes } from './news-routes';
import { NotificationsRoutes } from './notifications-routes';
import { OnlineResourcesRoutes } from './online-resources-routes';
import { PackagesRoutes } from './packages-routes';
import { ParentRoutes } from './parents-routes';
import { PaymentProcessorRoutes } from './payment-processor-routes';
import { PaymentRoutes } from './payment-routes';
import { PaymentSourceRoutes } from './payment-source-routes';
import { PayrollRoutes } from './payroll-routes';
import { PracticeLogRoutes } from './practice-logs-routes';
import { RepertoireRoutes } from './repertoire-routes';
import { ReportsRoutes } from './report-routes';
import { ReviewRoutes } from './review-routes';
import { SalesTaxRoutes } from './sales-tax-routes';
import { SchoolsRoutes } from './schools-routes';
import { SettingsRoutes } from './settings-routes';
import { StudentRoutes } from './students-routes';
import { TagRoutes } from './tag-routes';
import { TaxDefinitionsRoutes } from './tax-definitions-routes';
import { TeacherAvailabilityRoutes } from './teacher-availability-routes';
import { TeacherRoutes } from './teachers-routes';
import { TestSchoolGenerationRoutes } from './test-school-generation-routes';
import { TransactionCategoriesRoutes } from './transaction-categories-routes';
import { TransactionRoutes } from './transactions-routes';
import { WebhookLogRoutes } from './webhook-log-routes';
import { WebhooksRoutes } from './webhooks-routes';
import { WebsiteMediaLibraryRoutes } from './website-media-library-routes';
import { WebsiteRoutes } from './website-routes';

export namespace ApiRoutes {
    export const Attendance = AttendanceRoutes;
    export const AttendanceNoteTemplate = AttendanceNoteTemplateRoutes;
    export const Authentication = AuthenticationRoutes;
    export const BillingProfiles = BillingProfilesRoutes;
    export const Calendar = CalendarRoutes;
    export const Cash = CashRoutes;
    export const CashCategory = CashCategoryRoutes;
    export const Country = CountryRoutes;
    export const Currency = CurrencyRoutes;
    export const EmailMediaLibrary = EmailMediaLibraryRoutes;
    export const EmailAddressVerification = EmailAddressVerificationRoutes;
    export const EventCategory = EventCategoryRoutes;
    export const EventLocation = EventLocationRoutes;
    export const Families = FamilyRoutes;
    export const HealthCheck = HealthCheckRoutes;
    export const Assets = AssetsRoutes;
    export const IntegrationsApiKeys = IntegrationsApiKeysRoutes;
    export const Invoices = InvoicesRoutes;
    export const LendingLibrary = LendingLibraryRoutes;
    export const Localization = LocalizationRoutes;
    export const MapLocation = MapLocationRoutes;
    export const Membership = MembershipRoutes;
    export const MessageTemplate = MessageTemplateRoutes;
    export const Messaging = MessagingRoutes;
    export const Mileage = MileageRoutes;
    export const News = NewsRoutes;
    export const Notifications = NotificationsRoutes;
    export const OnlineResources = OnlineResourcesRoutes;
    export const Packages = PackagesRoutes;
    export const Parents = ParentRoutes;
    export const Payment = PaymentRoutes;
    export const PaymentProcessor = PaymentProcessorRoutes;
    export const PaymentSource = PaymentSourceRoutes;
    export const Payroll = PayrollRoutes;
    export const PracticeLogs = PracticeLogRoutes;
    export const Repertoire = RepertoireRoutes;
    export const Reports = ReportsRoutes;
    export const Reviews = ReviewRoutes;
    export const SalesTax = SalesTaxRoutes;
    export const Schools = SchoolsRoutes;
    export const Settings = SettingsRoutes;
    export const Students = StudentRoutes;
    export const Tags = TagRoutes;
    export const TaxDefinitions = TaxDefinitionsRoutes;
    export const Teachers = TeacherRoutes;
    export const TeacherAvailability = TeacherAvailabilityRoutes;
    export const TestSchoolGeneration = TestSchoolGenerationRoutes;
    export const TransactionCategories = TransactionCategoriesRoutes;
    export const Transactions = TransactionRoutes;
    export const WebhookLogs = WebhookLogRoutes;
    export const Webhooks = WebhooksRoutes;
    export const WebsiteMediaLibrary = WebsiteMediaLibraryRoutes;
    export const Website = WebsiteRoutes;
};

export type StudentPortalRoutes = Omit<typeof ApiRoutes, 'AttendanceNoteTemplate' | 'Cash' | 'CashCategory' | 'Currency' | 'HealthCheck' | 'IntegrationsApiKeys' | 'Localization' | 'MapLocation' | 'Membership' | 'MessageTemplate' | 'Mileage' | 'Notifications' | 'Payment' | 'PaymentProcessor' | 'Payroll' | 'Reports' | 'SalesTax' | 'Schools' | 'TaxDefinitions' | 'TeacherAvailability' | 'TeacherPayrollOverride' | 'TestSchoolGeneration' | 'TransactionCategories' | 'WebhookLogs' | 'Webhooks' | 'Website' | 'WebsiteMediaLibrary'>;

export type TeacherPortalRoutes = Omit<typeof ApiRoutes, 'TestSchoolGeneration'>;
